import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import outputs from './amplify_outputs.json';
import App from './App.js';
import './App.css';

const originalAuth = outputs.Auth || {};
Amplify.configure({
  ...outputs,
  Auth: {
    ...originalAuth,
    signOutRedirectTo: '/',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
